(() => {
  'use strict';
  if (window.__isportAuditFixes) return;
  window.__isportAuditFixes = true;
  const isHe = () => (document.documentElement.lang || '').toLowerCase().startsWith('he');
  const drawers = new WeakSet();
  function syncDrawer() {
    const drawer = document.getElementById('DrawerMenu');
    if (!drawer) return;
    const update = () => {
      const btn = document.getElementById('DrawerMenuToggler');
      if (btn) btn.setAttribute('aria-expanded', String(drawer.classList.contains('is-opened')));
      return btn;
    };
    update();
    if (drawers.has(drawer)) return;
    drawers.add(drawer);
    let wasOpen = drawer.classList.contains('is-opened');
    new MutationObserver(() => {
      const open = drawer.classList.contains('is-opened');
      if (open === wasOpen) return;
      wasOpen = open;
      const btn = update();
      if (open || !btn) return;
      const a = document.activeElement;
      if (!a || a === document.body || drawer.contains(a)) btn.focus({ preventScroll: true });
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }
  function predictiveEnabled() {
    const el = document.getElementById('shopify-features');
    if (!el) return null;
    try {
      const v = JSON.parse(el.textContent).predictiveSearch;
      return typeof v === 'boolean' ? v : null;
    } catch (e) { return null; }
  }
  let hintSeq = 0;
  function addHint(host) {
    const form = host.querySelector('form');
    if (!form || form.querySelector('.isport-search-hint')) return;
    const p = document.createElement('p');
    p.className = 'isport-search-hint';
    p.id = 'isport-search-hint-' + (++hintSeq);
    p.textContent = isHe()
      ? 'הקלידו מילת חיפוש ולחצו Enter כדי לראות את כל התוצאות.'
      : 'Type a search term and press Enter to see all results.';
    form.appendChild(p);
    const input = form.querySelector('input[name="q"]');
    if (input) {
      const ids = (input.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
      ids.push(p.id);
      input.setAttribute('aria-describedby', ids.join(' '));
    }
  }
  function hintAll() {
    if (predictiveEnabled() !== false) return;
    document.querySelectorAll('search-sidebar-form-wrapper').forEach(addHint);
  }
  customElements.whenDefined('search-sidebar-form-wrapper').then(() => {
    const C = customElements.get('search-sidebar-form-wrapper');
    const orig = C && C.prototype.renderFromUrl;
    if (typeof orig !== 'function' || orig.__isportWrapped) return;
    const wrapped = function (...args) {
      if (predictiveEnabled() !== false) return orig.apply(this, args);
      addHint(this);
      return Promise.resolve();
    };
    wrapped.__isportWrapped = true;
    C.prototype.renderFromUrl = wrapped;
    hintAll();
  });
  function init() { syncDrawer(); hintAll(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
